// DcData.tsx
import React from "react";
// Import the SVG icons as React components (optional, or use your own icons)
import { ReactComponent as IconEdit } from "../../../../shared/assets/Icons/Icon_Edit.svg";
import { ReactComponent as IconDelete } from "../../../../shared/assets/Icons/Icon_Delete.svg";
import { GenericTableColumn } from "@ui-components/Table/GenericTable";

/**
 * This interface now includes all potential fields for a Data Center,
 * but we store "capacity" as a number in the frontend, 
 * while the backend uses "capacityKW" as a string.
 */
export interface DataCenter {
    datacenterId: string;
    name: string;
    direction: string;
    gps: string;
    capacity: number;      // We'll show "Capacity (KW)" but store it as a number
    phase: string;
    cage: string;
    rackId: string;
    rackCapacity: number;
    patchPanelODF: string;
    rackSecurityPin: string;
    status: string;
	visible: boolean;
	providerId: string;
	providerCode: string;
	city: string;
	displayName: string;
}

/**
 * Define table columns using our interface.
 * Only some fields (Name, Direction, Capacity, Status) are displayed in the table.
 */
export const columns: GenericTableColumn<DataCenter>[] = [
    {
        header: "Name",
        accessor: "name",
    },
    {
        header: "Direction",
        accessor: "direction",
    },
    {
        header: "Capacity (KW)",
        accessor: "capacity", // This is a number in the DataCenter interface
    },
    {
        header: "Status",
        accessor: "status",
    },
    {
        header: "Actions",
        // We only need a valid string for 'accessor'; real rendering is in renderCell
        accessor: "name",
        renderCell: (row) => (
            <div className="flex items-center gap-2">
                {/* View Button */}
                <button
                    className="
            px-3 py-1
            border border-semantic-border-secondary
            rounded
            text-semantic-text-secondary
            hover:bg-semantic-state-active
          "
                    onClick={() => {
                        console.log("View data center:", row);
                    }}
                >
                    View
                </button>

                {/* Edit Button */}
                <button
                    className="
            flex items-center justify-center
            border border-semantic-border-secondary
            rounded
            text-semantic-text-secondary
            hover:bg-semantic-state-active
            w-10 h-10
          "
                    onClick={() => {
                        console.log("Edit data center:", row);
                    }}
                >
                    <IconEdit className="w-5 h-5" />
                </button>

                {/* Delete Button */}
                <button
                    className="
            p-2
            border border-semantic-border-secondary
            rounded
            bg-red-50
            text-red-600
            hover:bg-red-100
          "
                    onClick={() => {
                        console.log("Delete data center:", row);
                    }}
                >
                    <IconDelete className="w-5 h-5" />
                </button>
            </div>
        ),
    },
];

/**
 * Example data for the table with all extra fields populated.
 * The table will only show Name, Direction, Capacity, Status,
 * but everything else is available for 'View' or 'Edit' in the modal.
 */

